import React, { type CSSProperties } from "react";
import type { ButtonKey } from "../../constants/gamepad";
import { Button } from "./Button";

interface DPadButtonProps {
  buttonKey: ButtonKey;
  iconConfig: {
    src1x: string;
    src2x: string;
    src3x: string;
  };
  onTouchStart: (e: React.TouchEvent, buttonKey?: ButtonKey) => void;
  onTouchEnd: (e: React.TouchEvent, buttonKey?: ButtonKey) => void;
  onMouseDown: (e: React.MouseEvent, buttonKey?: ButtonKey) => void;
  onMouseUp: (e: React.MouseEvent, buttonKey?: ButtonKey) => void;
  direction: "up" | "down" | "left" | "right";
  style?: CSSProperties;
}

export const DPadButton: React.FC<DPadButtonProps> = ({
  buttonKey,
  iconConfig,
  onTouchStart,
  onTouchEnd,
  onMouseDown,
  onMouseUp,
  direction,
  style = {},
}) => {
  const directionStyle =
    baseStyles[
      `dpad${
        direction.charAt(0).toUpperCase() + direction.slice(1)
      }` as keyof typeof baseStyles
    ];

  return (
    <Button
      buttonKey={buttonKey}
      iconConfig={iconConfig}
      style={{
        ...baseStyles.dpadButton,
        ...directionStyle,
        ...style,
      }}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
    />
  );
};

const baseStyles: { [key: string]: CSSProperties } = {
  dpadButton: {
    position: "absolute",
    width: 48,
    height: 48,
    borderRadius: "50%",
  },
  dpadUp: { top: "0", left: "50%", transform: "translateX(-50%)" },
  dpadDown: { bottom: "0", left: "50%", transform: "translateX(-50%)" },
  dpadLeft: { left: "0", top: "50%", transform: "translateY(-50%)" },
  dpadRight: { right: "0", top: "50%", transform: "translateY(-50%)" },
};
